import { ReactElement } from 'react';

function Home(): ReactElement {
  return <div> Welcome to SBULL Tech</div>;
}

export default Home;
